import { styled } from '@mui/material';

export const ValidationErrorMessage = styled('span')`
  color: ${({ theme }) => theme.text?.validation};
  font-weight: 400;
`;
